module.exports = __webpack_public_path__ + "static/img/Coppens-Godeliva.db4b33b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Coppens-Godeliva.jpg
// module id = Uutg
// module chunks = 1